import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import { GetAllAwardsDocument, BuyAwardDocument, SearchAwardsDocument } from './schema.graphql';
import { Awards, BuyAwardMutation, BuyAwardMutationVariable, SearchAwardsQuery, SearchAwardsQueryVariables } from 'src/app/model/award';
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };


// A query GetAllAwardsGQL nao aceita variaveis; o documento e fixo.
export type GetAllAwardsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllAwardsQuery = { getAllAwards: Awards[] };

@Injectable({
  providedIn: 'root'
})

export class GetAllAwardsGQL extends Apollo.Query<GetAllAwardsQuery, GetAllAwardsQueryVariables>{
  document = GetAllAwardsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root'
})

export class BuyAwardGQL extends Apollo.Mutation<BuyAwardMutation, BuyAwardMutationVariable>{
  document = BuyAwardDocument;

  constructor(apollo: Apollo.Apollo){
    super(apollo);
  }
}

@Injectable({
  providedIn: 'root'
})
export class SearchAwardsGQL extends Apollo.Query<SearchAwardsQuery, SearchAwardsQueryVariables> {
  document = SearchAwardsDocument;
  
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
